// @ts-check
import { Trans } from '@lingui/macro';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import ValidateIdentifier, {
  useIdentifierValidation,
} from '../identifierValidation/IdentifierValidation';
import {
  ProgressIndicator,
  bottlebooksFieldsSource,
  newProductsFieldsToImport,
  useLink,
} from './_config';

export default function IdentifierNewProductsValidation({ match }) {
  const link = useLink('identifierNewProductsValidation');
  const { workspaceId, importId } = match.params;
  const props = useIdentifierValidation({ workspaceId, importId });

  return (
    <Layout>
      <ProgressIndicator step="validate" />
      <PageHeader>
        <PageTitle>
          <Trans>Data Validation</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>Ensure your data is valid and ready to import.</Trans>
        </PageSubtitle>
      </PageHeader>
      <Main>
        <ValidateIdentifier
          {...props}
          masterListColumns={uniq(
            [...newProductsFieldsToImport, ...bottlebooksFieldsSource],
            'key'
          )}
        />
      </Main>
      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton to={link.next()} disabled={!props.isValid}>
          <Trans>Next</Trans>
        </NextButton>
      </Footer>
    </Layout>
  );
}

function uniq(arr, key) {
  return arr.filter(
    (obj, index, self) => self.findIndex((o) => o[key] === obj[key]) === index
  );
}
